import React from 'react';
import { Flex, Box } from '@chakra-ui/react';
import { GlobalFooter } from '@/components/global-footer/global-footer';
import { AppHeader } from '@/components/app-header';
import { DevBanner } from '@/components/dev-banner/dev-banner';

export interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <Flex direction="column" minH="100vh">
      <AppHeader />
      <Box flex="1">{children}</Box>
      <GlobalFooter />
      <DevBanner />
    </Flex>
  );
};

export default AppLayout;
